<template>
    <div class="scrollable-container">
        <div>
            <div class="search-bar-gray d-flex">
                <v-btn @click="handleSearch()"><v-icon>mdi-magnify</v-icon></v-btn>
                <v-text-field v-model="searchVal" solo :label="SearchLabel" @keydown.enter="searchFieldKeydownHandler"></v-text-field>
                <div class="custom-icon-wrapper" v-if="searchVal != ''">
					<v-icon @click="clear()">custom-icon mdi-close</v-icon>
                </div>
			</div>
            <v-treeview class="mt-4" ref="searchTree" dense :items="items" :load-children="buildChildTree" :open="openNodes"
                @update:open="handleCollapseChildren" activatable>
                <template v-slot:label="{ item }">
                    <div class="d-flex align-items-center">
                        <div class="d-flex align-items-center v-treeview-leaf-icons" v-if="item.isUser">
                            <v-checkbox v-if="singleValue == false" v-model="values" :value="item.id" dense></v-checkbox>
                            <v-checkbox v-else v-model="value" :value="item.id" dense></v-checkbox>
                        </div>
                        <div v-if="!item.isUser && allowStructureSelect">
                            <v-checkbox v-if="singleValue == false" v-model="values" :value="item.id" dense></v-checkbox>
                            <v-checkbox v-if="singleValue == true" v-model="value" :value="item.id" dense></v-checkbox>
                        </div>
                        <div v-if="!item.isUser">
                            <span v-if="item.childrens !== 0" class="v-treeview-node__inner-label"><v-icon v-if="item.isExternal" small class="mr-1" :color="blue">mdi-earth</v-icon>{{ lang == 'en' ? item.name : (item.nameAr != null ? item.nameAr : item.name) }} </span>
                            <span v-if="item.childrens === 0" class="v-treeview-node__inner-label v-treeview-leaf"><v-icon v-if="item.isExternal" small class="mr-1" :color="blue">mdi-earth</v-icon>{{ lang == 'en' ? item.name : (item.nameAr != null ? item.nameAr : item.name ) }} </span>
                            <!-- <span class="v-treeview-node__inner-label d-flex align-center"><v-icon small class="mr-1" :color="blue">mdi-earth</v-icon></span> -->
                        </div>
                        <div v-if="item.isUser" class="w-100">
                            <div class="d-flex justify-content-between w-100 v-treeview-node__inner-label v-treeview-leaf">
                                <div class="user-name w-70">
                                    {{ item.name }}
                                </div>
                                <div class="light-gray w-30" v-tooltip="item.profession">
                                    <span class="text-limit one-line">
                                        {{ item.profession }}
                                    </span>
                                </div>
                            </div>
                        </div>
                    </div>
                </template>
            </v-treeview>
            <div class="dialog-footer d-flex align-items-center justify-content-end gap-3">
                <v-btn color="light-blue" @click="closeAddressBook()">{{ $t("res_ButtonText_Cancel") }}</v-btn>
                <v-btn :disabled="AddDisabled" color="primary" @click="handleSelectFromAddressBook">{{ $t("res_ButtonText_Add") }}</v-btn>
            </div>
        </div>
    </div>
</template>

<script>
import axios from 'axios';
import constants from '@/assets/js/constants'
import * as utils from '@/assets/js/common.js'

export default {
    name: 'AddressBook',
    props: {
        singleValue: { type: Boolean, default: false },
        reset: { type: Number, default: 0 },
        showInternalStructures: { type: Boolean, default: false },
        showExternalStructures: { type: Boolean, default: false },
        showInternalUsers: { type: Boolean, default: false },
        showExternalUsers: { type: Boolean, default: false },
        disableOtherInternalEntitiesAsExternal: { type: Boolean, default: false },
        defaultValue: { type: Array, default: () => [] },
        allowStructureSelect: { type: Boolean, default: true },
        allowedUsersRoles: { type: Array, default: () => [] },
        isForSignee: { type: Boolean, default: false },
        excludeSelf: { type: Boolean, default: false },
        hideStructureWithDisableTransfer: { type: Boolean, default: false },
        loadOnlyInScopeInternalStrucutres: { type: Boolean, default: false },
        loadOnlyInScopeInternalUsers: { type: Boolean, default: false },
        calledFromField:{ type: String, default:"" },
        showAllInternal: { type: Boolean, default: false },
        ignorePermissions: { type: Boolean, default: false },
        sortInternalFirst: { type: Boolean, default: false }
    },
    data: () => ({
        items: [],
        all_items: [],
        open: [],
        active: [],
        isOpen: false,
        searchVal: '',
        nodeName: '',
        search_items: [],
        openNodes: [],
        newActive: false,
        dropDown: false,
        values: [],
        value: '',
        enableCheckBoxOnStructures: true,
        enableCheckBoxOnUsers: true,
        headers: {},
        selectedNodes: [],
        SearchLabel: '',
        AddDisabled: true,
    }),
    methods:
    {
        clearArray: function (item) {
            document.querySelector('.rateRecipe .btns-one-small').click();
        },
        buildChildTree(item) {
            return this.getData(item.id, (res) => {
                item.children = [];

                res.data.forEach(element => {
                    var newItem = {
                        id: element.userId == null ? element.id.toString() : element.userId + '-' + element.structureId,
                        name: element.name,
                        isUser: element.userId != null,
                        isChild: true,
                        profession: element.profession,
                        childrens: element.childrens,
                        children: [],
                        userId: element.userId,
                        structureId: element.structureId,
                        parentId: element.parentId,
                        isExternal : element.isExternal,
                        disableTransfers : element.disableTransfers,
                    };

                    this.all_items.push(newItem);
                    item.children.push(newItem);
                });

                if (!this.openNodes.some(x => x == item.id)) {
                    this.openNodes.push(item.id);
                }

            })
        },
        handleSearch: function () {
            if (this.searchVal) {
                if (this.searchVal.length < 4 && SearchValAtLeast4char == true) {
                    window.showAlert('res_Msgs_AtLeast4char', 'warning');
                    return;
                }
            }

            this.getData('', (res) => {
                this.lang = localStorage.getItem('lang') != null && localStorage.getItem('lang') != undefined ? localStorage.getItem('lang') : 'en';
                window.hideLoading()
                this.openNodes = [];
                this.all_items = [];

                var data = res.data;
                if (this.sortInternalFirst && Array.isArray(data)) {
                    data = data.slice().sort((a, b) => (a.isExternal ? 1 : 0) - (b.isExternal ? 1 : 0));
                }
                this.items = data
                this.items.forEach(ele => {
                    ele.id = ele.id.toString();
                    this.all_items.push(ele);
                    this.insertion(ele);
                });
            })
        },
        getData(parentId, onSuccess) {
            var params = "?search=" + this.searchVal +
                '&showInternalUsers=' + this.showInternalUsers +
                '&showExternalUsers=' + this.showExternalUsers +
                "&showInternal=" + this.showInternalStructures +
                "&showExternal=" + this.showExternalStructures +
                "&disableOtherInternalEntitiesAsExternal=" + this.disableOtherInternalEntitiesAsExternal +
                '&isForSignee=' + this.isForSignee +
                '&calledFromField=' + this.calledFromField +
                '&allowedUsersRoles=' + (this.allowedUsersRoles && this.allowedUsersRoles.length > 0 ? this.allowedUsersRoles : "") +
                '&excludeSelf=' + this.excludeSelf +
                '&hideStructureWithDisableTransfer=' + this.hideStructureWithDisableTransfer +
                '&loadOnlyInScopeInternalStrucutres=' + this.loadOnlyInScopeInternalStrucutres +
                '&loadOnlyInScopeInternalUsers=' + this.loadOnlyInScopeInternalUsers +
                '&parentId=' + (parentId ? parentId : "") +
                '&showAllInternal='+this.showAllInternal +
                '&ignorePermissions=' + this.ignorePermissions

            window.showLoading()
            axios.get(constants.baseApiUrl + 'StructureUser/GetStructursUsers' + params)
                .then(res => {
                    onSuccess(res);
                })
                .catch(err => console.warn(err))
                .finally(() => window.hideLoading())
        },
        insertion: function (ele) {
            ele.isUser = ele.userId != null;
            ele.isChild = true;

            if (ele.children.length > 0) {
                ele.children.forEach(item => {
                    this.all_items.push(item);
                    this.insertion(item)
                });
                if (this.searchVal) {
                    this.openNodes.push(ele.id)
                }
            }
        },
        clear() {
            this.searchVal = '';
            this.items = [];
            this.openNodes = [];
            this.handleSearch();
        },
        closeAddressBook() {
            this.$emit('closeAddressBook');
        },
        handleSelectFromAddressBook() {
            if (this.singleValue) {
                if (this.value == '') {
                    window.showAlert('res_Msgs_SelectAtLeastOne', 'warning');
                    return;
                }

                var foundItem = this.all_items.find(x => x.id == this.value);
                if (foundItem != null) {
                    if (foundItem.isUser)
                        retVal = {
                            id: foundItem.userId + '-' + foundItem.structureId,
                            name: foundItem.name,
                            isUser: foundItem.isUser,
                            external: foundItem.isExternal,
                        }
                    else
                        retVal = {
                            id: foundItem.id,
                            name: foundItem.name,
                            isUser: foundItem.isUser,
                            external: foundItem.isExternal,
                        }
                        
                        if(this.hideStructureWithDisableTransfer && foundItem.disableTransfers){
                            window.showAlert(this.$t("res_Msg_NotAllowedToSelectThisStructure"), 'error');
                            return;
                        }
                }

                var validationRes = this.validateSelection([retVal]);

                if (validationRes) {
                    this.$emit('handleSelectFromAddressBook', retVal);
                }
            }
            else {
                if (this.values.length == 0) {
                    window.showAlert('res_Msgs_SelectAtLeastOne', 'warning');
                    return;
                }

                var retVal = []
                this.values.forEach(element => {
                    var foundItem = this.all_items.find(x => x.id == element);
                    if (foundItem != null) {
                        if (foundItem.isUser)
                            retVal.push({ id: foundItem.userId + '-' + foundItem.structureId, name: foundItem.name, isUser: foundItem.isUser, external: foundItem.isExternal });
                        else{
                            if(!(this.hideStructureWithDisableTransfer && foundItem.disableTransfers)){
                                retVal.push({ id: foundItem.id, name: foundItem.name, isUser: foundItem.isUser, external: foundItem.isExternal }); 
                            }
                        }
                    }
                });

                this.values = []

                var validationRes = this.validateSelection(retVal);

                if (validationRes) {
                    this.$emit('handleSelectFromAddressBook', retVal);
                }
            }
        },
        validateSelection(selectedValues) {
            if (!this.allowStructureSelect) {
                if (selectedValues.some((item) => !item.isUser)) {
                    window.showAlert('res_Msgs_StructureIsNotAllowedForSelect', 'warning');
                    return false;
                }
            }

            return true;
        },
        resetAddressBook() {
            this.items = [];
            this.all_items = [];
            this.searchVal = '';
            this.value = '';
            this.values = [];
            this.defaultValue.forEach(el => {
                if (el.id) {
                    el.id = el.id.toString();
                }
            });

            this.handleSearch();
        },
        CapitalizeFirstLetter(string) {
            return utils.CapitalizeFirstLetter(string)
        },
        searchFieldKeydownHandler() {
            this.handleSearch()
        },
        handleCollapseChildren(openNodes) {
            this.openNodes = openNodes;
        }
    },
    computed: {
        selectedNodeObject() {
            return {
                name: this.defaultValue.name,
                checked: true
            }
        }
    },
    mounted() {
        this.SearchLabel = window.translate("res_Label_SearchPlaceHolder")
        this.handleSearch();
        this.headers = { 'Authorization': 'Bearer ' + sessionStorage.getItem('jwt_token') }
    },
    watch:
    {
        values: function (newVal, oldVal) {
            if (newVal.length > 0) {
                this.AddDisabled = false
            }
            else {
                this.AddDisabled = true
            }

        },
        value: function (newVal, oldVal) {
            if (newVal != null && newVal != '') {
                this.AddDisabled = false
            }
            else {
                this.AddDisabled = true
            }
        },
        reset: function (newVal, oldVal) {
            this.resetAddressBook();
        }
    }
}
</script>

<style>
.v-messages {
    display: none !important;
}
</style>